/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/quotes */
import type { SVGProps } from "react";
const SvgCreationSparkles = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <g clipPath="url(#CreationSparkles_svg__a)">
      <path
        fill="#7139B0"
        d="m15.833.833-1.05 2.292L12.5 4.167l2.283 1.05 1.05 2.283 1.042-2.283 2.292-1.05-2.292-1.042M7.5 3.333 5.417 7.917.833 10l4.584 2.083L7.5 16.667l2.083-4.584L14.167 10 9.583 7.917m6.25 4.583-1.05 2.283-2.283 1.05 2.283 1.042 1.05 2.292 1.042-2.292 2.292-1.042-2.292-1.05"
      />
    </g>
    <defs>
      <clipPath id="CreationSparkles_svg__a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgCreationSparkles;
